import { pb } from './pb';

const LS_KEY = 'favorites.products';

export function loadFavoritesLS() {
  try {
    const raw = localStorage.getItem(LS_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr : [];
  } catch { return [] }
}

export function saveFavoritesLS(items) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(items || [])); } catch { }
}

export function isLoggedIn() {
  try { return !!pb?.authStore?.isValid && !!pb?.authStore?.model?.id; } catch { return false }
}

export async function fetchFavoritesPB() {
  if (!isLoggedIn()) return [];
  const userId = pb.authStore.model.id;
  const list = await pb.collection('favorites').getFullList({
    filter: `user = "${userId}"`,
    expand: 'product',
    sort: '-created'
  });
  return (list || []).map(r => {
    const p = r.expand?.product;
    if (!p) return null;
    return {
      id: p.id,
      slug: p.slug,
      title: p.title,
      images: Array.isArray(p.images) ? p.images : [],
      collectionId: p.collectionId,
      collectionName: p.collectionName || 'products'
    };
  }).filter(Boolean);
}

export async function addFavoritePB(productId) {
  if (!isLoggedIn()) return null;
  const userId = pb.authStore.model.id;
  try {
    // Vérifier si déjà présent pour éviter l'erreur 400 (Bad Request)
    const existing = await pb.collection('favorites').getList(1, 1, {
      filter: `user = "${userId}" && product = "${productId}"`
    });
    if (existing.items.length > 0) return existing.items[0];

    return await pb.collection('favorites').create({ user: userId, product: productId });
  } catch (e) {
    return null;
  }
}

export async function removeFavoritePB(productId) {
  if (!isLoggedIn()) return null;
  const userId = pb.authStore.model.id;
  const list = await pb.collection('favorites').getFullList({ filter: `user = "${userId}" && product = "${productId}"` });
  await Promise.all(list.map(r => pb.collection('favorites').delete(r.id)));
}

export async function removeAllFavoritesPB() {
  if (!isLoggedIn()) return null;
  const userId = pb.authStore.model.id;
  const list = await pb.collection('favorites').getFullList({ filter: `user = "${userId}"` });
  await Promise.all(list.map(r => pb.collection('favorites').delete(r.id)));
}

export async function mergeLocalWithPB() {
  if (!isLoggedIn()) return loadFavoritesLS();
  const ls = loadFavoritesLS();
  const pbItems = await fetchFavoritesPB();
  const map = new Map();
  // On remplit le map avec les items du serveur en priorité
  for (const it of pbItems) { if (it?.id) map.set(it.id, it); }

  // On ajoute les items locaux s'ils n'existent pas sur le serveur
  const lsOnly = [];
  for (const it of ls) {
    if (it?.id && !map.has(it.id)) {
      map.set(it.id, it);
      lsOnly.push(it);
    }
  }

  const merged = Array.from(map.values());
  // On n'envoie au serveur que ce qui manque réellement
  if (lsOnly.length > 0) {
    await Promise.allSettled(lsOnly.map(x => addFavoritePB(x.id)));
  }
  saveFavoritesLS(merged);
  return merged;
}
